//引入外部模組
import {transitionEnd} from '@/common';




//縣市區域
class City {
  constructor(el, thisEl, idA) {
    this.el            = el;
    this.thisEl        = thisEl;
    // this.printEl       = this.thisEl.find('span');
    this.cityEl        = this.el.find('.selectCity');
    this.areaEl        = this.el.find('.selectArea');
    this.printEl       = $('.city').find('span');
    // this.cityEl        = $('.selectCity');
    // this.areaEl        = $('.selectArea');
    this.idA           = idA;
    this.allEl         = this.areaEl.find('#' + this.idA + 'All');
    this.dataAreaEl    = this.areaEl.find('.data');
    // this.dataAreaEl    = $('.city').find('.data');

    this.searchForm    = $('#rwdSearchForm'); //右側側邊搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋

    this.resoultCity = '';
    this.resoultArea = '';
  }
  //搜尋類別-初始化
  tabsReturn(el) {
    el.on('change', () => {
      this.dataAreaEl.empty();
      this.printEl.html('縣市區域');
    });
  }
  //返回縣市
  backCity(areaSelect) {
    this.areaEl.find('.back').on('click', () => {
      this.areaEl.removeClass('active').one(transitionEnd, () => {
        //清空區域 DOM & 選取
        this.areaEl.find(areaSelect).prop('checked', false);
        this.dataAreaEl.empty();
        //返回清空縣市選取
        this.cityEl.find('input[type=radio]').prop('checked', false);
        this.cityEl.addClass('active');
        this.printEl.html('縣市區域');
      });
    });
  }
  //模組1
  cityModule1(cityType) {
    //判斷是否有選取，如無選取，引入縣市資料
    //如有選取，直接跳入區域選取
    let checkedNum = this.areaEl.find(':checkbox:checked').length;
    // let checkedNum = $('.selectArea').find(':checkbox:checked').length;
    
    if(checkedNum != 0){
      this.areaEl.addClass('active');
      // $('.selectArea').addClass('active');
    } else {
      //尚未選取，開起城市選單
      this.thisEl.next(this.cityEl).addClass('active');
      // console.log('打開城市');
      //縣市區域切換選取
      this.cityEl.find(':radio').each((i, j) => {
        $(j).off('change').on('change', () => {

          //跳出縣市選項時，則清空舊有條件(昀寬多加)
          // console.log('打開區選單');
          // $('.searchCancel').html(''); //清除舊有資料區(城市、區都清)
          if($(j).is(':checked')){
            $('.cityAreaInput').val('');//舊有條件移除(縣市、區皆移除)
            //記錄縣市並顯示縣市文字
            this.resoultCity = $(j).val();
            this.printEl.html(this.resoultCity);
            $('#cityString').val( $(j).val() );//將城市資料丟進input

            //切換區域選取
            this.cityEl.removeClass('active').one(transitionEnd, () => {
              this.areaEl.addClass('active');
            });
            
            /*
            $('.selectCity').removeClass('active').one(transitionEnd, () => {
              $('.selectArea').addClass('active');
            }); 
            */
            //引入區域資料
            $.post('ajax_obj_realty_area.php', {cityId: i, type: cityType}, (areaData) => {
              //清除原有資料(城市、縣市)

              $('.searchCancel').html('');
              //產生 DOM
              this.dataAreaEl.append(areaData);
              //改成開啟兩邊的area選擇
              // $('.city').find('.data').append(areaData);

              //預設區域不限
              this.allEl.prop('checked', true);
              // $('.selectArea .selectAll').find(':checkbox').prop('checked', true); //兩邊全選

              //區域選項
              // $('.selectArea').find(':checkbox').change((e) => {
              this.areaEl.find(':checkbox').change((e) => {
                // console.log('點擊cehckbox進入');
                // console.log('join');
                const $this       = $(e.currentTarget);
                const $cbEl       = this.dataAreaEl.find(':checkbox');
                let checkedLength = this.dataAreaEl.find(':checkbox:checked').length;
                // const $cbEl       = $('.selectArea').find(':checkbox');
                // let checkedLength = $('.selectArea').find(':checkbox:checked').length;
                // let checkedLength = this.el.find('.data :checkbox:checked').length; //記算筆數
                //已選擇數組
                // let areaVal =  this.dataAreaEl.find(':checkbox:checked').map(function() { return $(this).val() }).get().join(","); //抓取已有的區域資料
                //---判斷其它form是否以一樣的項目，並做同步選取
                let checkName   = $this.attr('name'); //找出選取的name值
                let checkVal    = $this.attr('value'); //找出選取的值
                let checkStatus = $this.prop('checked'); //勾選狀態
                // console.log( checkName +":"+ checkVal +":"+ checkStatus );

                $('form input[name="'+checkName+'"]').each((index, element) => {
                    if(checkVal == $(element).attr('value')) {
                      // $(element).attr('checked',checkStatus); 
                      $(element).prop('checked',checkStatus);    
                    } //if(checkVal == $(element).attr('value')) {
                });
                //---判斷其它form是否以一樣的項目，並做同步選取

                // console.log('這是那裡,我是誰,我在幹嘛1');

                //顯示縣市 & 已選取區域總數目結果文字
                let printTxt = () => {
                  this.resoultArea = ' 已選擇<i>' + checkedLength + '</i>筆';
                  this.printEl.html(this.resoultCity + this.resoultArea);
                }
                //若其它區域無選取，則返回區域不限
                let checkBackAll = () => {
                  if(checkedLength == 0) {
                    this.allEl.prop('checked', true);
                    // $('.selectArea .selectAll checkbox').prop('checked', true);
                    this.printEl.html(this.resoultCity);
                  }
                }
                if($this.is('#' + this.idA + 'All')){
                  //選取區域不限
                  if($this.is(':checked')){
                    $cbEl.prop('checked', false);
                    this.printEl.html(this.resoultCity);
                  }else{
                    checkBackAll();
                  }
                }else if(checkedLength >= $cbEl.length){
                  //若選取全部，則返回區域不限
                  $cbEl.prop('checked', false);
                  this.allEl.prop('checked', true);
                  this.printEl.html(this.resoultCity);
                }else{
                  //選取其它區域
                  if($this.is(':checked')){
                    this.allEl.prop('checked', false);
                    printTxt();
                  }else{
                    printTxt();
                    checkBackAll();
                  }
                }
              });
            });
          }
        });
      });
      //返回縣市
      this.backCity('input[type=checkbox]');
    }
  }
  //模組2
  cityModule2(cityType) {
    //判斷是否有選取，如無選取，引入縣市資料
    //如有選取，直接跳入區域選取
    let checkedNum = this.areaEl.find(':radio:checked').length;
    if(checkedNum != 0){
      this.areaEl.addClass('active');
    } else {
      this.thisEl.next(this.cityEl).addClass('active');

      // $('.cityAreaInput').val('');//舊有條件移除(縣市、區皆移除)
      this.cityEl.find(':radio').prop('checked', false);//舊有條件移除(縣移除)

      //縣市區域切換選取
      this.cityEl.find(':radio').each((i, j) => {
        $(j).off('change').on('change', () => {
          if($(j).is(':checked')){
            //記錄縣市並顯示縣市文字
            this.resoultCity = $(j).val();
            this.printEl.html(this.resoultCity);
            
            //切換區域選取
            this.cityEl.removeClass('active').one(transitionEnd, () => {
              this.areaEl.addClass('active');
            });
            //引入區域資料
            $.post('ajax_obj_realty_area.php', {cityId: i, type: cityType}, (areaData) => {
              //產生 DOM
              // this.dataAreaEl.append(areaData);
              this.dataAreaEl.html(areaData);

              //比對是否有訂閱此輸出的區域
              let areaClassArray = $('.areaClass').val(); //只會有一筆
              
              if(areaClassArray) {
                //有訂閱 - 區
                this.areaEl.find(':radio').each((i, e) => {
                  if(e.value == areaClassArray) {
                    //e為物件型態
                    e.setAttribute('checked', true);
                  }
                }); //areaData.find(':radio').each((e) => {

              } else {
                //無訂閱 - 預設區域不限
                this.allEl.prop('checked', true);
              }

              //區域選項
              this.areaEl.find(':radio').change((e) => {
                const $this       = $(e.currentTarget);
                const $cbEl       = this.dataAreaEl.find(':radio');
                let cbVal         = this.dataAreaEl.find(':radio:checked').val();
                let checkedLength = this.dataAreaEl.find(':radio:checked').length;

                //清空舊有條件
                $('.searchCancel').html(' ');
                //顯示縣市 & 已選取區域結果文字
                let printTxt = () => {
                  this.resoultArea = ' -<i>' + cbVal + '</i>';
                  this.printEl.html(this.resoultCity + this.resoultArea);
                }
                //若其它區域無選取，則返回區域不限
                let checkBackAll = () => {
                  if(checkedLength == 0) {
                    this.allEl.prop('checked', true);
                    this.printEl.html(this.resoultCity);
                  }
                }
                if($this.is('#' + this.idA + 'All')){
                  //選取區域不限
                  if($this.is(':checked')){
                    $cbEl.prop('checked', false);
                    this.printEl.html(this.resoultCity);
                  }else{
                    checkBackAll();
                  }
                }else if(checkedLength >= $cbEl.length){
                  //若選取全部，則返回區域不限
                  $cbEl.prop('checked', false);
                  this.allEl.prop('checked', true);
                  this.printEl.html(this.resoultCity);
                }else{
                  //選取其它區域
                  if($this.is(':checked')){
                    this.allEl.prop('checked', false);
                    printTxt();
                  }else{
                    printTxt();
                    checkBackAll();
                  }
                }
              });
            });
          }
        });
      });
      //返回縣市
      this.backCity('input[type=radio]');
    }
  }
}




//建立模組
class SelectModule {
  constructor(thisEl, idS, idL, returnTxt, idTxt, unit) {
    this.thisEl    = thisEl;
    this.printEl   = this.thisEl.find('span');
    this.selectEl  = this.thisEl.next('.selectBox');
    this.dataEl    = this.selectEl.find('.data');
    this.cbEl      = this.dataEl.find(':checkbox');
    this.allCBL    = this.dataEl.find(':checkbox:checked').length;
    this.allCBLRad = this.dataEl.find(':radio:checked').length;

    this.idS       = idS;
    this.idL       = idL;
    this.returnTxt = returnTxt;
    this.idTxt     = idTxt;
    this.unit      = unit;
    this.allEl     = this.selectEl.find('#' + this.idS + 'All'); //全部選取checkbox
    // this.allEl     = $('#' + this.idS + 'All'); //全部選取checkbox
    this.minEl     = $('#min' + this.idL); //最小值
    this.maxEl     = $('#max' + this.idL); //最大值
    this.moreEl    = this.selectEl.find('li.' + this.idS);

    this.searchForm    = $('#rwdSearchForm'); //右側側邊搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋

    this.divName = this.printEl.parents('div').attr('class'); //抓出目前所在範圍的div名稱
    this.objName = $('.'+this.divName); //宣告成object
    this.inputText = $('.'+this.divName).find('.inputBox input[type=tel]');//此區塊的數字欄位

    this.resoult     = ''; //最後結果
    this.pushArray   = []; //選取後加入陣列(篩選比對用)
    this.filterArray = []; //篩選比對後陣列
    this.min         = ''; //最小值
    this.max         = ''; //最大值
  }

  //點擊搜尋類別初始化
  tabsReturn(el) {
    el.on('change', () => {
      this.printEl.html(this.returnTxt);
    });
  }
  
  //顯示結果文字
  printTxt(txt) {
    switch(txt){
      case 'between':
        this.resoult = '<i>' + this.minEl.val() + '</i>' + this.unit + ' -' + '<i>' + this.maxEl.val() + '</i>' + this.unit;
        break;
      case 'up':
        this.resoult = '<i>' + this.minEl.val() + '</i>' + this.unit + '以上';
        break;
      case 'down':
        this.resoult = '<i>' + this.maxEl.val() + '</i>' + this.unit + '以下';
        break;
      case 'only':
        this.resoult = '<i>' + this.maxEl.val() + '</i>' + this.unit;
        break;
    }
    // this.printEl.html(this.resoult);
    this.objName.find('.selectBtn span').html(this.resoult);
  }
  //預設選取不限
  checkAll() {
    if(this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == ''){
      this.allEl.prop('checked', true);
      this.printEl.html(this.idTxt + '不限');
      // this.objName.find('.selectAll :checkbox').prop('checked', true); //選取底下的checkbox all
      // this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
    }
  }
  //若其它無選取，則返回不限
  checkBackAll() {
    this.pushArray.length   = 0;
    this.filterArray.length = 0;
    // this.cbEl.prop('checked', false);
    // this.allEl.prop('checked', true);
    // this.minEl.val('');
    // this.maxEl.val('');
    //一起處理有同名的divname
    // console.log(this.objName);
    this.objName.find(':checkbox').prop('checked', false); //將底下所有checkbox取消選取
    this.objName.find(':radio').prop('checked', false); //將底下所有radio取消選取
    this.objName.find('.selectAll :checkbox').prop('checked', true); //選取底下的checkbox all
    this.objName.find('.inputBox input').val('');
    this.objName.find('.inputBox input').val('');
  }
  //僅輸入數字
  onlyNumber() {
    this.minEl.add(this.maxEl).on('input', (e) => {
      const $this   = $(e.currentTarget);
      let filterVal = $this.val().replace(/[！-～]/g, (tmpStr) => {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      });
      $this.val(filterVal.replace(/[^0-9]/g, ''));
    });
  }
  //欄位輸入(輸出文字)
  inputCheckPublic() {
    let check = (e, range, m1, m2) => {
      const $this = $(e.currentTarget);
      this.pushArray.length   = 0;
      this.filterArray.length = 0;
      this.allEl.prop('checked', false);
      this.cbEl.prop('checked', false);
      //顯示結果文字
      if($this.val() != '' &&  range.val() == ''){
        this.printTxt(m1);
      }else if($this.val() == '' && range.val() != ''){
        this.printTxt(m2);
      }else if($this.val() == '' && range.val() == ''){
        this.allEl.prop('checked', true);
        this.printEl.html(this.idTxt + '不限');
      }else{
        this.printTxt('between');
      }
    }
    this.minEl.keyup((e) => {
      check(e, this.maxEl, 'up', 'down');
    });
    this.maxEl.keyup((e) => {
      check(e, this.minEl, 'down', 'up');
    });
    //僅輸入數字
    this.onlyNumber();
  }
  //欄位輸入
  inputCheck() {
    let check = (e, range) => {
      const $this = $(e.currentTarget);
      this.pushArray.length   = 0;
      this.filterArray.length = 0;
      this.allEl.prop('checked', false);
      this.cbEl.prop('checked', false);
      //無輸入返回不限
      if($this.val() == '' && range.val() == ''){
        this.allEl.prop('checked', true);
      }
    }
    this.minEl.keyup((e) => {
      check(e, this.maxEl);
    });
    this.maxEl.keyup((e) => {
      check(e, this.minEl);
    });
    //僅輸入數字
    this.onlyNumber();
  }
  //最小最大值
  minMax() {
    //設為空陣列
    this.pushArray.length   = 0;
    this.filterArray.length = 0;
    //移除文字，僅留下數字
    this.dataEl.find(':checkbox:checked').each((index, el) => {
      let num = $(el).val().match(/\d+/g);
      if(num != null){
        $.map(num, (x, y) => {
          //傳至陣列
          return this.pushArray.push(x);
        });
      }else{
        return;
      }
      //過濾重覆數字
      this.filterArray = this.pushArray.filter((x, y, z) => {
        return z.indexOf(x) === y;
      });
    });
    //最小最大值
    this.min = Math.min(...this.filterArray);
    this.max = Math.max(...this.filterArray);
  }
  //模組1(總價、建坪)
  module1() {
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    this.checkAll();
    //欄位輸入(輸出文字)
    this.inputCheckPublic();
    //選取後動作
    this.selectEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;

      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態

      $('form input[name="'+checkName+'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            // $(element).attr('checked',checkStatus); 
            $(element).prop('checked', checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });
      //---判斷其它form是否以一樣的項目，並做同步選取
      if($this.is(this.allEl)){
        //選取不限
        this.checkBackAll();
        // this.printEl.html(this.idTxt + '不限');
        this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
      }else{
        // this.allEl.prop('checked', false); //取消選取all
        
        this.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false
        
        //選取比對後顯示
        let resoultTxt = () => {
          //最小最大值
          this.minMax();
          // if($('#' + this.idS + 'Down').is(':checked')){
          if(  this.objName.find('.data input[type=checkbox]:first').is(':checked')){
            //XXX以下
            this.inputText.eq(0).val('');
            this.inputText.eq(1).val(this.max);
            this.inputText.eq(2).val('');
            this.inputText.eq(3).val(this.max);
            // this.minEl.val('');
            // this.maxEl.val(this.max);
            //顯示結果文字
            //$('.'+this.divName).find('.selectBtn span').html();
            this.printTxt('down');
          // }else if($('#' + this.idS + 'Up').is(':checked')){
          }else if( this.objName.find('.data input[type=checkbox]:last').is(':checked')){ 
            //XXX以上
            // this.minEl.val(this.min);
            // this.maxEl.val('');
            this.inputText.eq(0).val(this.min);
            this.inputText.eq(1).val();
            this.inputText.eq(2).val(this.min);
            this.inputText.eq(3).val();
            //顯示結果文字
            this.printTxt('up');
          }else{
            // this.minEl.val(this.min);
            // this.maxEl.val(this.max);
            this.inputText.eq(0).val(this.min);
            this.inputText.eq(1).val(this.max);
            this.inputText.eq(2).val(this.min);
            this.inputText.eq(3).val(this.max);
            //顯示結果文字
            this.printTxt('between');
          }
          //XXX以下 & XXX以上同時選取，則返回不限
          if($('#' + this.idS + 'Down').is(':checked') && $('#' + this.idS + 'Up').is(':checked')){
            // this.cbEl.prop('checked', false);
            this.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false
            //若其它無選取，則返回不限
            this.checkBackAll();
            // this.printEl.html(this.idTxt + '不限');
            this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
          }
        }
        //選取其它
        if($this.is(':checked')){
          //選取比對後顯示
          resoultTxt();
        }else{
          //選取比對後顯示
          resoultTxt();
          //若其它無選取，則返回不限
          if(dataCBL == 0){
            this.checkBackAll();
            // this.printEl.html(this.idTxt + '不限');
            this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
          }
        }
      }
      

    }); // this.selectEl.find(':checkbox').on('change', (e) => {
  }
  //模組2(房數)
  module2(){
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    this.checkAll();
    //欄位輸入(輸出文字)
    this.inputCheckPublic();
    //選取後動作
    this.selectEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;

      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態

      $('form input[name="'+checkName+'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });

      //---判斷其它form是否以一樣的項目，並做同步選取

      if($this.is(this.allEl)){
        //選取不限
        this.checkBackAll();
        this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
        // this.printEl.html(this.idTxt + '不限');
      }else{
        // this.allEl.prop('checked', false);
        this.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false

        //選取比對後顯示
        let resoultTxt = () => {
          //最小最大值
          this.minMax();
          if($('#' + this.idS + 'Up').is(':checked')){
          // if(  this.objName.find('.data input[type=checkbox]:first').is(':checked')){
            //XXX以上
            // this.minEl.val(this.min);
            // this.maxEl.val('');
            this.inputText.eq(0).val(this.min);
            this.inputText.eq(1).val('');
            this.inputText.eq(2).val(this.min);
            this.inputText.eq(3).val('');
            //顯示結果文字
            this.printTxt('up');
          }else{
            if(dataCBL >= 2){
              // this.minEl.val(this.min);
              // this.maxEl.val(this.max);
              this.inputText.eq(0).val(this.min);
              this.inputText.eq(1).val(this.max);
              this.inputText.eq(2).val(this.min);
              this.inputText.eq(3).val(this.max);
              //顯示結果文字
              this.printTxt('between');
            }else{
              // this.minEl.val('');
              // this.maxEl.val(this.max);
              this.inputText.eq(0).val('');
              this.inputText.eq(1).val(this.max);
              this.inputText.eq(2).val('');
              this.inputText.eq(3).val(this.max);
              //顯示結果文字
              this.printTxt('only');
            }
          }
        }
        //選取其它
        if($this.is(':checked')){
          //選取比對後顯示
          resoultTxt();
        }else{
          //選取比對後顯示
          resoultTxt();
          //若其它無選取，則返回不限
          if(dataCBL == 0){
            this.checkBackAll();
            // this.printEl.html(this.idTxt + '不限');
            this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
          }
        }
      }
    });
  }
  //模組3(物件類型)(地圖用)
  module3(){
    
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    if(this.allCBL == 0){
      this.allEl.prop('checked', true);
      this.printEl.html('類型不限');
    }
    //選取後動作
    this.selectEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;
      //顯示總數目結果文字
      let printTxt = () => {
        this.printEl.html('類型 已選擇<i>' + dataCBL + '</i>筆');
      }
      //若其它無選取，則返回不限
      let checkBackAll = () => {
        this.cbEl.prop('checked', false);
        this.allEl.prop('checked', true);
        this.printEl.html('類型不限');
      }
      if($this.is(this.allEl)){
        //選取不限
        checkBackAll();
      }else if(dataCBL >= this.cbEl.length){
        //若選取全部，則返回不限
        checkBackAll();
      }else{
        //選取其它
        if($this.is(':checked')){
          this.allEl.prop('checked', false);
          printTxt();
        }else{
          printTxt();
          if(dataCBL == 0) {
            checkBackAll();
          }
        }
      }
    });
  }
  //模組4(直接顯示內容在title上, 內容為checkbox)(地圖用)
  module4(){
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    // this.checkAll();
    // this.allEl.prop('checked', true);
    
    if(this.allCBL == 0){
      this.allEl.prop('checked', true);
      // this.printEl.html('類型不限');
    }
    
    //選取後動作
    this.selectEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;
      //顯示總數目結果文字
      let printTxt = () => {
        this.printEl.html(' 已選擇<i>' + dataCBL + '</i>筆');
      }
      //若其它無選取，則返回不限
      let checkBackAll = () => {
        this.cbEl.prop('checked', false);
        this.allEl.prop('checked', true);
        this.printEl.html(this.idTxt + '不限');
      }
      if($this.is(this.allEl)){
        //選取不限
        checkBackAll();
      }else if(dataCBL >= this.cbEl.length){
        //若選取全部，則返回不限
        checkBackAll();
      }else{
        //選取其它
        if($this.is(':checked')){
          this.allEl.prop('checked', false);
          printTxt();
        }else{
          printTxt();
          if(dataCBL == 0) {
            checkBackAll();
          }
        }
      }
    });
  }
  //模組5(直接顯示內容在title上, 內容為radio)(地圖用)
  module5(){
    // console.log('進入module5');
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    // this.checkAll();
    // this.allEl.prop('checked', true);
    //看radio是否已經有選取的數量，若未選取擇預設不限
    if(this.allCBLRad == 0){
      this.allEl.prop('checked', true);
      // this.printEl.html('類型不限');
    }
    
    //選取後動作
    this.selectEl.find(':radio').on('change', (e) => {

      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':radio:checked').length; //選取數量
      //this.cbEl.length : 全部長度
      //顯示總數目結果文字
      
      
      //若其它無選取，則返回不限
      let checkBackAll = () => {
        this.cbEl.prop('checked', false);
        this.allEl.prop('checked', true);
        this.printEl.html(this.idTxt + ' 不限');
      }

      if($this.is(this.allEl)){
        //選取不限
        checkBackAll();
      }else{
        //單一選單，將value送回標題
        this.printEl.html( this.idTxt + ' ' + e.currentTarget.defaultValue  );
      }

    }); //this.selectEl.find(':radio').on('change', (e) => {
  }

  //進階搜尋-模組1
  moduleMore1() {
    this.dataEl = this.moreEl.find('.data');
    this.cbEl   = this.dataEl.find(':checkbox');
    this.thisAllCBL = this.dataEl.find(':checkbox:checked').length;

    //打開
    this.selectEl.addClass('active');
    //欄位輸入
    this.inputCheck();
    //預設選取不限
    // if(this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == ''){
    if (this.thisAllCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == '') {  
      this.allEl.prop('checked', true);
    }

    //選取後動作(屋齡)
    // console.log(this.moreEl);
    
    this.moreEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;
      // console.log('123');
      // console.log(this.dataEl);
      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態

      $('form input[name="'+ checkName +'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            $(element).prop('checked',checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });
      //---判斷其它form是否以一樣的項目，並做同步選取

      if($this.is(this.allEl)){
        //選取不限
        // this.checkBackAll();
        var name_div = this.allEl.parents('li').find('.data li input').attr('name');//取消底下所選的checkbox的name值
        $('input[name="'+name_div+'"]').prop('checked', false); //取消選取(電腦、手機都要)
        $('#objMoreYearsAll').prop('checked', true); //電腦版(全選勾選)
        $('#moreYearsAll').prop('checked', true); //手機版(全選勾選)
        $('input[name="house_year_start"]').val(' '); //取消input
        $('input[name="house_year_end"]').val(' ');  //取消input
      }else{
        this.allEl.prop('checked', false);
        // $('input[name="'+checkName+'"]').prop('checked', false);
        // this.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false
        //選取比對後顯示
        let resoultTxt = () => {
          //最小最大值
          this.minMax();
          if($('#' + this.idS + 'Down').is(':checked')){
            //XXX以下
            // this.minEl.val('');
            // this.maxEl.val(this.max);
            $('#minObjMoreYears').val('');
            $('#maxObjMoreYears').val(this.max);
            $('#minMoreYears').val('');
            $('#maxMoreYears').val(this.max);
          }else if($('#' + this.idS + 'Up').is(':checked')){
            //XXX以上
            // this.minEl.val(this.min);
            // this.maxEl.val('');
            $('#minObjMoreYears').val(this.min);
            $('#maxObjMoreYears').val('');
            $('#minMoreYears').val(this.min);
            $('#maxMoreYears').val('');
          }else{
            // this.minEl.val(this.min);
            // this.maxEl.val(this.max);
            // console.log(this.inputText);
            $('#minObjMoreYears').val(this.min);
            $('#maxObjMoreYears').val(this.max);
            $('#minMoreYears').val(this.min);
            $('#maxMoreYears').val(this.max);
          }
          //XXX以下 & XXX以上同時選取，則返回不限
          if($('#' + this.idS + 'Down').is(':checked') && $('#' + this.idS + 'Up').is(':checked')){
            this.cbEl.prop('checked', false);
            //若其它無選取，則返回不限
            this.checkBackAll();
          }
        }
        //選取其它
        if($this.is(':checked')){
          //選取比對後顯示
          resoultTxt();
        }else{
          //選取比對後顯示
          resoultTxt();
          //若其它無選取，則返回不限
          if(dataCBL == 0){
            this.checkBackAll();
          }
        }
      }
    });
  }
  //進階搜尋-模組2(樓層)
  moduleMore2() {
    this.dataEl = this.moreEl.find('.data');
    this.cbEl   = this.dataEl.find(':checkbox');
    this.thisAllCBL = this.dataEl.find(':checkbox:checked').length;

    //打開
    this.selectEl.addClass('active');
    //欄位輸入
    this.inputCheck();
    //預設選取不限
    // if(this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == ''){
    if (this.thisAllCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == '') {  
      this.allEl.prop('checked', true);
    }
    //選取後動作
    this.moreEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;

      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態
      // console.log( checkName +":"+ checkVal +":"+ checkStatus );

      $('form input[name="'+ checkName +'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            $(element).prop('checked',checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });
      //---判斷其它form是否以一樣的項目，並做同步選取

      if($this.is(this.allEl)){
        //選取不限
        // this.checkBackAll();
        var name_div = this.allEl.parents('li').find('.data li input').attr('name');//取消底下所選的checkbox的name值
        $('input[name="'+name_div+'"]').prop('checked', false); //取消選取(電腦、手機都要)
        $('#objMoreFAll').prop('checked', true); //電腦版(全選勾選)
        $('#moreFAll').prop('checked', true); //手機版(全選勾選)
        $('input[name="floor_nums_start"]').val(' '); //取消input
        $('input[name="floor_nums_end"]').val(' ');  //取消input
      }else{
        // this.allEl.prop('checked', false);
        $('#objMoreFAll').prop('checked', false); //取消樓層不限
        $('#moreFAll').prop('checked', false); //取消樓層不限


        //選取比對後顯示
        let resoultTxt = () => {
          //最小最大值
          this.minMax();
          if($('#' + this.idS + 'Up').is(':checked')){
            //XXX以上
            // this.minEl.val(this.min);
            // this.maxEl.val('');
            $('#minObjMoreF').val(this.min);
            $('#maxObjMoreF').val('');
            $('#minMoreF').val(this.min);
            $('#maxMoreF').val('');
          }else{
            if(this.filterArray.length >= 2){
              // this.minEl.val(this.min);
              // this.maxEl.val(this.max);
              $('#minObjMoreF').val(this.min);
              $('#maxObjMoreF').val(this.max);
              $('#minMoreF').val(this.min);
              $('#maxMoreF').val(this.max);
            }else{
              // this.minEl.val('');
              // this.maxEl.val(this.max);
              $('#minObjMoreF').val('');
              $('#maxObjMoreF').val(this.max);
              $('#minMoreF').val('');
              $('#maxMoreF').val(this.max);
            }
          }
        }
        //選取其它
        if($this.is(':checked')){
          //選取比對後顯示
          resoultTxt();
        }else{
          //選取比對後顯示
          resoultTxt();
          //若其它無選取，則返回不限
          if(dataCBL == 0){
            this.checkBackAll();
          }
        }
      }
    });
  }
  //進階搜尋-模組3(車位、預售屋)
  moduleMore3() {
    this.dataEl = this.moreEl.find('.data');
    this.thisAllCBL = this.dataEl.find(':radio:checked').length; //檢查選取的長度

    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    // if(this.allCBL == 0){
    if (this.thisAllCBL == 0) {
      this.allEl.prop('checked', true);
    }
    this.moreEl.find(':radio').on('change', (e) => {
      const $this = $(e.currentTarget);

      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態

      $('form input[name="'+ checkName +'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            $(element).prop('checked',checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });
      //---判斷其它form是否以一樣的項目，並做同步選取
    });
    
  }
  //進階搜尋-模組4(特色環境)
  moduleMore4() {
    this.dataEl     = this.moreEl.find('.data');
    this.thisAllCBL = this.dataEl.find(':checkbox:checked').length; //檢查選取的長度
    this.cbEl       = this.dataEl.find(':checkbox');
    //打開
    this.selectEl.addClass('active');
    //預設選取不限
    // if(this.allCBL == 0){
      if (this.thisAllCBL == 0) {  
      this.allEl.prop('checked', true);
    }
    //選取後動作
    this.moreEl.find(':checkbox').on('change', (e) => {
      const $this = $(e.currentTarget);
      let dataCBL = this.dataEl.find(':checkbox:checked').length;

      //---判斷其它form是否以一樣的項目，並做同步選取
      var checkName   = $this.attr('name'); //找出選取的name值
      var checkVal    = $this.attr('value'); //找出選取的值
      var checkStatus = $this.prop('checked'); //勾選狀態

      $('form input[name="'+ checkName +'"]').each((index, element) => {
          if(checkVal == $(element).attr('value')) {
            $(element).prop('checked',checkStatus);    
          } //if(checkVal == $(element).attr('value')) {
      });
      //---判斷其它form是否以一樣的項目，並做同步選取

      // console.log(checkName);
      // alert(checkName); 

      //若其它無選取，則返回不限
      let checkBackAll = () => {
        // this.cbEl.prop('checked', false); //將checkbox取消選取
        // this.allEl.prop('checked', true); //將all選取
        $('form input[name="more_features"]').prop('checked', false); //底下的checkbox取消選取
        $('#moreFeaturesAll').prop('checked', true);
        $('#objMoreFeaturesAll').prop('checked', true);
      }
      if($this.is(this.allEl)){
        //選取不限
        checkBackAll();
      }else if(dataCBL >= this.cbEl.length){
        //若選取全部，則返回不限
        checkBackAll();
      }else{
        //選取其它
        if($this.is(':checked')){
          // this.allEl.prop('checked', false); //將all取消選取
          $('#moreFeaturesAll').prop('checked', false);
          $('#objMoreFeaturesAll').prop('checked', false);
        }else{
          if(dataCBL == 0) {
            checkBackAll();
          }
        }
      }
    });
  }
  
}




//搜尋類別
class SearchCategory {
  constructor(el) {
    this.searchEl = el;
    this.tabs     = this.searchEl.find('.tabs label');
    this.tabsRD   = this.searchEl.find('.tabs :radio');

    this.selectCity    = this.searchEl.find('.city');
    this.selectPrice   = this.searchEl.find('.price');
    this.selectRent    = this.searchEl.find('.rent');
    this.selectFloor   = this.searchEl.find('.floor'); //建坪
    this.selectFloorB  = this.searchEl.find('.floorB'); //地坪
    this.selectRoom    = this.searchEl.find('.room');
    this.bar           = this.searchEl.find('.bar');
    this.searchInput   = this.bar.find('input');
    this.selectMore    = this.searchEl.find('.more');
    this.btn           = this.searchEl.find('.btn');

    this.selectTxt = this.searchEl.find(':text, input[type="tel"]');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
    this.selectCB  = this.selectBox.find(':checkbox');
    this.selectRD  = this.selectBox.find(':radio');
  }
  //初始化
  tabsReturn() {
    this.tabsRD.on('change', () => {
      this.selectBtn.removeClass('active');
      this.selectBox.removeClass('active');
      this.selectTxt.val('');
      this.selectCB.prop('checked', false);
      this.selectRD.prop('checked', false);
    });
  }
  //控制
  selectCtrl(i){
    this.searchEl.find('.box >div').hide();
    this.selectCity.show();
    this.bar.show();
    this.btn.show();
    switch(i) {
      case 1:
        this.selectRent.show();
        this.selectFloor.show();
        this.selectRoom.show();
        this.selectMore.show();
        break;
      case 10:
      case 11:
      case 12:
      case 13:
        this.selectPrice.show();
        this.selectFloorB.show();
        break;
      case 14:
      default:
        this.selectPrice.show();
        this.selectFloor.show();
        this.selectRoom.show();
        this.selectMore.show();
        break;
    }
  }
  //切換
  toggleSelected() {
    //判斷是否有帶進來的值，做初始選取(若無則預設全部)
    let classNumberValue = $('#class_number').val(); //類別值
    let classNumberValString = $('#areaSearch').attr('vv'); //選取的中文字
    let navValue = $('.scrollBox #nav').val(); //目前頁面

    if (classNumberValue != 0) {
      $('.searchBox .tabs li').find('label').eq(classNumberValue).addClass('active'); //變色選取(網頁版)
      $('.scrollBox .tabs li').find('label').eq(classNumberValue).addClass('active'); //變色選取(手機版)
      this.selectCtrl(parseInt(classNumberValue));
    } else {
      //預設「全部」類別(分為買屋、租屋)
      if( navValue == 'rent' ) {
        $('.searchBox .tabs li').find('label').eq(1).addClass('active'); //變色選取(網頁版)
        $('.scrollBox .tabs li').find('label').eq(1).addClass('active'); //變色選取(手機版)
        this.selectCtrl(1);
        $('#class_number').val(1); //儲存物件類型的編號，預設0 kai
      } else {
        $('.searchBox .tabs li').find('label').eq(0).addClass('active'); //變色選取(網頁版)
        $('.scrollBox .tabs li').find('label').eq(0).addClass('active'); //變色選取(手機版)
        this.selectCtrl(0);
        $('#class_number').val(0); //儲存物件類型的編號，預設0 kai
      }
    }
    
    //切換類別
    this.tabs.each((i, e) => {
      $(e).on('click', () => {
        this.tabs.removeClass('active');
        $(e).addClass('active');
        this.selectCtrl(i);
        $('#class_number').val(i); //儲存物件類型的編號 kai
      });
    });
  }
  //打開選取 & 關閉
  selected() {
    //搜尋類別-初始化
    this.tabsReturn();
    //搜尋類別-切換
    this.toggleSelected();
    //狀態預設
    let removeSelectBox = () => {
      this.selectBtn.removeClass('active');
      this.selectBox.removeClass('active');
    }
    //關閉選取
    //Body
    $('body').on('click', () => {
      removeSelectBox();
    });
    //輸入欄位
    this.searchInput.focusin(() => {
      // console.log(this.searchInput.attr('name'));
      removeSelectBox();
    });
    //同步輸入欄位(關鍵字)
    this.searchInput.on('keyup blur', (event) => {
      const $this   = $(event.currentTarget);
      let inputName = $this.attr('name'); //name值
      $('input[name="'+inputName+'"]').val($this.val());
    });

    //選取框
    this.selectBox.on('click', (event) => {
      //點擊外圍關閉Bug
      event.stopPropagation();
    });
    
    //打開選取
    this.selectBtn.each((i, e) => {
      $(e).off('click').on('click', (event) => {
        // $(e).on('click', (event) => {
        // console.log('點擊處1');
        // console.log($(e));
        //點擊外圍關閉Bug
        event.stopPropagation();
        $(e).toggleClass('active');
        if($(e).is('.active')){
          removeSelectBox();
          $(e).addClass('active');
          if(this.searchEl.is('#rwdSearch')){
            //Rwd Menu (手機版本)
            switch(i){
              //縣市區域
              case 0: 
                let city = new City(this.searchEl, $(e), 'area');
                city.tabsReturn(this.tabsRD);
                // city.cityModule1('search');//header
                city.cityModule1('header');//header
                break;
              //總價預算
              case 1:
                
                let price = new SelectModule($(e), 'price', 'Price', '總價預算', '總價', '萬');
                price.tabsReturn(this.tabsRD);
                price.module1();
                break;
              //租金預算
              case 2:
                let rent = new SelectModule($(e), 'rent', 'Rent', '租金預算', '租金', '元');
                rent.tabsReturn(this.tabsRD);
                rent.module1();
                break;
              //建坪
              case 3:
                let floor = new SelectModule($(e), 'floor', 'Floor', '建坪', '建坪', '坪');
                floor.tabsReturn(this.tabsRD);
                floor.module1();
                break;
              //地坪
              case 4:
                let floorB = new SelectModule($(e), 'floorB', 'FloorB', '地坪', '地坪', '坪');
                floorB.tabsReturn(this.tabsRD);
                floorB.module1();
                break;
              //房數
              case 5:
                let room = new SelectModule($(e), 'room', 'Room', '房數', '房數', '房');
                room.tabsReturn(this.tabsRD);
                room.module2();
                break;
              //進階搜尋
              case 6:
                let moreYears    = new SelectModule($(e), 'moreYears', 'MoreYears', '', '', '');
                let moreF        = new SelectModule($(e), 'moreF', 'MoreF', '', '', '');
                let moreParking  = new SelectModule($(e), 'moreParking', '', '', '', '');
                let moreFeatures = new SelectModule($(e), 'moreFeatures', '', '', '', '');
                let moreKeyWordSelect = new SelectModule($(e), 'moreKeyWordSelect', '', '', '', '');
                moreYears.moduleMore1();
                moreF.moduleMore2();
                moreParking.moduleMore3();
                moreFeatures.moduleMore4();
                moreKeyWordSelect.moduleMore3();
                break;
            }
          }else if(this.searchEl.is('#objSearch')){
            //物件列表 (網頁版) 
            switch(i){
              //縣市區域
              case 0:
                let city = new City(this.searchEl, $(e), 'objArea');
                city.tabsReturn(this.tabsRD);
                // city.cityModule1('search');
                city.cityModule1('header');
                break;
              //總價預算
              case 1:
                let price = new SelectModule($(e), 'objPrice', 'ObjPrice', '總價預算', '總價', '萬');
                price.tabsReturn(this.tabsRD);
                price.module1();
                break;
              //租金預算
              case 2:
                let rent = new SelectModule($(e), 'objRent', 'ObjRent', '租金預算', '租金', '元');
                rent.tabsReturn(this.tabsRD);
                rent.module1();
                break;
              //建坪
              case 3:
                let floor = new SelectModule($(e), 'objFloor', 'ObjFloor', '建坪', '建坪', '坪');
                floor.tabsReturn(this.tabsRD);
                floor.module1();
                break;
              //地坪
              case 4:
                let floorB = new SelectModule($(e), 'objFloorB', 'ObjFloorB', '地坪', '地坪', '坪');
                floorB.tabsReturn(this.tabsRD);
                floorB.module1();
                break;
              //房數
              case 5:
                let room = new SelectModule($(e), 'objRoom', 'ObjRoom', '房數', '房數', '房');
                room.tabsReturn(this.tabsRD);
                room.module2();
                break;
              //進階搜尋
              case 6:
                let moreYears         = new SelectModule($(e), 'objMoreYears', 'ObjMoreYears', '', '', '');
                let moreF             = new SelectModule($(e), 'objMoreF', 'ObjMoreF', '', '', '');
                let moreParking       = new SelectModule($(e), 'objMoreParking', '', '', '', '');
                let moreFeatures      = new SelectModule($(e), 'objMoreFeatures', '', '', '', '');
                let moreKeyWordSelect = new SelectModule($(e), 'objMoreKeyWordSelect', '', '', '', '');
                moreYears.moduleMore1();
                moreF.moduleMore2();
                moreParking.moduleMore3();
                moreFeatures.moduleMore4();
                moreKeyWordSelect.moduleMore3();
                break;
            }
          }
        }else{
          removeSelectBox();
        }
      });
    });
    //送出搜尋
    this.btn.find('button').on('click', () => {
      $('body').addClass('active');
    });

    //點擊移除搜尋結果的條件
    $('.delSearch').parents('li').on('click', (e) => {
      const $this = $(e.currentTarget);
      let className = $this.attr('data-info');
      if(className == 'city') {
        //城市被取消時，區也要取消

        $('.box .city').find('span').html('縣市區域');//改搜尋條件title
        $('.searchCancel').html(' '); //搜尋條件欄位歸0
        $this.remove(); //搜尋結果:移除城市
        $('.searchStatus[data-info=area]').remove(); //搜尋結果:移除區

      } else if(className == 'area') {
        //因區有多選問題，需再判斷那一區的
        
        $this.remove(); //搜尋結果:移除區
        // console.log('區');
        $('#areaSearch').find('input').each(function() {
          // console.log($(this).val()+'==='+$this.find('.delSearch').attr('data-info'));
          if( $(this).val() == $this.find('.delSearch').attr('data-info') ) {
            $(this).remove();
            // console.log( $(this).val() );
          }
         
        });
        //移除搜尋條件
      } else {
        //直接勾選不選
        
      }
     
    });
  }
}




//Search
class Search {
  searchObj() {
    //Rwd Menu
    let rwdSearch = new SearchCategory($('#rwdSearch'));
    rwdSearch.selected();

    //物件列表
    let objSearch = new SearchCategory($('#objSearch'));
    objSearch.selected();
  }
}




//---地圖找屋
class MapSearch {
  constructor() {
    this.searchEl  = $('#mapSelectBar');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
  }
  //打開選取 & 關閉
  selected() {
    //狀態預設
    let removeSelectBox = () => {
      this.selectBtn.removeClass('active');
      this.selectBox.removeClass('active');
    }
    //打開選取
    this.selectBtn.each((i, e) => {
      $(e).on('click', (event) => {
        //點擊外圍關閉Bug
        // console.log('點擊開啟&關閉選單');
        event.stopPropagation();
        $(e).toggleClass('active'); //切換外圍選單的方向icon
        if($(e).is('.active')){
          removeSelectBox();
          $(e).addClass('active'); 
          switch(i){
            //縣市區域
            case 0:
              let city = new City(this.searchEl, $(e), 'tbArea');
              city.cityModule2('mapSearch');
              break;
            //物件類型
            case 1:
              let classes = new SelectModule($(e), 'tbClasses', '', '物件類型', '', '');
              classes.module3();
              break;
            //總價預算
            case 2:
              let price = new SelectModule($(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
              price.module1();
              break;
            //坪數
            case 3:
              let floor = new SelectModule($(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
              floor.module1();
              break;
              
            //地坪
            case 4:
              let floorB = new SelectModule($(e), 'floorB', 'FloorB', '地坪', '地坪', '坪');
              // floorB.tabsReturn(this.tabsRD);
              floorB.module1();
              break;

            //房數
            case 5:
              let room = new SelectModule($(e), 'room', 'Room', '房數', '房數', '房');
              // room.tabsReturn(this.tabsRD);
              room.module1();
              break;

            //屋齡
            case 6:
              let moreYears    = new SelectModule($(e), 'moreYears', 'MoreYears', '屋齡', '屋齡', '年');
              // room.tabsReturn(this.tabsRD);
              moreYears.module1();
              break;  
            //樓層
            case 7:
              let moreF = new SelectModule($(e), 'moreF', 'MoreF', '樓層', '樓層', '層');
              // room.tabsReturn(this.tabsRD);
              moreF.module1();
              break; 
            //車位
            case 8:
              let moreParking = new SelectModule($(e), 'moreParking', 'MoreParking', '車位', '車位', '');
              // room.tabsReturn(this.tabsRD);
              moreParking.module5();
              break;     
            //特色環境
            case 9:
              let moreFeatures = new SelectModule($(e), 'moreFeatures', 'MoreFeatures', '環境', '環境', '');
              // room.tabsReturn(this.tabsRD);
              moreFeatures.module4();
              break;
            //預售屋
            case 10:
              let moreKeyWordSelect = new SelectModule($(e), 'moreKeyWordSelect', 'MoreKeyWordSelect', '預售屋', '預售屋', '');
              // room.tabsReturn(this.tabsRD);
              moreKeyWordSelect.module5();
              break;            
              
          }
          this.selectBox.on('click', (event) => {
            //點擊外圍關閉Bug
            event.stopPropagation();
          });
          //關閉
          $(document).on('click', () => {
            removeSelectBox();
          });
        }else{
          removeSelectBox();
        }
      });
    });
  }
  

}




//實價登錄
class ActualSearch {
  constructor() {
    this.nav       = $('#navVal').val();
    this.searchEl  = $('#toggleSelectBar');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
    this.closeBtn  = this.selectBox.find('.close');
  }
  //打開選取 & 關閉
  selected() {
    //狀態預設
    let removeSelectBox = () => {
      this.selectBtn.removeClass('active');
      this.selectBox.removeClass('active');
    }
    //打開選取
    this.selectBtn.each((i, e) => {
      $(e).off('click').on('click', (event) => {
        // console.log('切換');
        // console.log($(e));
        //點擊外圍關閉Bug
        event.stopPropagation();
        $(e).toggleClass('active');
        if($(e).is('.active')){
          removeSelectBox();
          $(e).addClass('active');
          $(e).next('.selectBox').toggleClass('active'); //增加選擇底下的selectBox並給class
          switch(i){
            //縣市區域
            case 0:
              let city = new City(this.searchEl, $(e), 'tbArea');
              city.cityModule1('actual');
              break;
            //總價預算 / 租金預算 (成交總價) 
            case 1:
              if(this.nav == 'actual_buy'){
                //let price = new SelectModule(this.searchEl, $(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
                let price = new SelectModule( $(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
                console.log(price);
                price.module1();
              }else if(this.nav == 'actual_rent'){
                // let rent = new SelectModule(this.searchEl, $(e), 'tbRent', 'Rent_tb', '租金預算', '租金', '元');
                let rent = new SelectModule($(e), 'tbRent', 'Rent_tb', '租金預算', '租金', '元');
                rent.module1();
              }
              break;
            //坪數
            case 2:
              // let floor = new SelectModule(this.searchEl, $(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
              let floor = new SelectModule($(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
              floor.module1();
              break;
          }
          this.selectBox.on('click', (event) => {
            //點擊外圍關閉Bug
            event.stopPropagation();
          });
          //關閉
          $(document).on('click', () => {
            removeSelectBox();
          });
          this.closeBtn.on('click', () => {
            removeSelectBox();
          });
        }else{
          removeSelectBox();
        }
      });
    });
  }
}




//輸出
export {Search, MapSearch, ActualSearch};


// WEBPACK FOOTER //
// ./js_new/search_list.js